/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'certificate-management-custom-params-grid';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleSensitive = `${prefix}.columnTitleSensitive`;
export const columnTitleDynamic = `${prefix}.columnTitleDynamic`;
export const customScriptParamsLabel = `${prefix}.customScriptParamsLabel`;

export const ENGLISH = {
    [columnTitleSensitive]: 'Sensitive',
    [columnTitleDynamic]: 'Dynamic',
    [customScriptParamsLabel]: 'Custom Script Params ({0})',
};
